module.exports = __webpack_public_path__ + "img/ltkpopulartoday-2x.ec6062d.jpg";